module.exports = __webpack_public_path__ + "img/star.22184631.png";